import React from "react";
import Skeleton from "thermo/skeleton/Skeleton";

export const LoadingRecentItem = () => {
  return <Skeleton data-testid="recentItemLoadingSkeleton" className="w-full h-8" />;
};
